import { cn } from 'lib/helpers/utility';

export const baseButtonClasses =
  'flex flex-row justify-center items-center gap-1.5 rounded py-0 cursor-pointer';
export const textButtonClasses = 'font-medium flex items-center justify-center';

export const buttonTextSizes = {
  xs: 'text-xs',
  small: 'text-sm',
  medium: 'text-base',
  large: 'text-lg'
};

export const buttonSizes = {
  xs: 'h-6 px-2',
  small: 'h-8 px-3',
  medium: 'h-10 px-3',
  large: 'h-12 px-4'
};

export const widthButtonSizes = {
  xs: 'w-6 p-0',
  small: 'w-8 p-0',
  medium: 'w-10 p-0',
  large: 'w-12 p-0'
};

export const buttonIconSizes = {
  xs: 16,
  small: 18,
  medium: 20,
  large: 24
};

const generateVariants = (baseColor, text, shade, hoverShade, activeShade) =>
  cn(
    `bg-${baseColor}-${shade} text-${text} hover:bg-${baseColor}-${hoverShade} active:bg-${baseColor}-${activeShade} disabled:bg-${baseColor}-${shade} disabled:text-${text} active:text-white`
  );

const generateOutlinedVariants = (
  baseColor,
  text,
  shade,
  hoverShade,
  activeShade,
  hoverBgShade,
  activeBgShade
) =>
  cn(
    `border border-solid bg-white border-${baseColor}-${shade} text-${text} hover:border-${baseColor}-${hoverShade} active:border-${baseColor}-${activeShade} disabled:border-${baseColor}-${shade} disabled:text-${text}`,
    hoverBgShade && `hover:bg-${baseColor}-${hoverBgShade} disabled:hover:bg-white`,
    activeBgShade && `active:bg-${baseColor}-${activeBgShade} disabled:active:bg-white`
  );

const generateLinkVariants = (baseColor, text, shade, hoverShade, activeShade) => {
  if (baseColor === 'white') {
    return cn(`text-white hover:opacity-80 p-0`);
  }

  return cn(
    `text-${text} hover:text-${baseColor}-${hoverShade} active:text-${baseColor}-${activeShade} p-0 disabled:text-${text}`
  );
};

export const generateButtonVariants = (color = 'primary', shade) => ({
  primary: {
    default: generateVariants(color, '[color:var(--color-on-primary,#fff)]', shade, 600, 700),
    outlined: generateOutlinedVariants(color, `${color}-${shade}`, 200, 700, 100)
  },
  secondary: {
    default: `rounded-full ${generateVariants(color, `${color}-${shade}`, 50, 50, 700)}`,
    outlined: `rounded-full ${generateOutlinedVariants(color, `${color}-${shade}`, 200, 700, 100)}`
  },
  tertiary: {
    default: cn(generateOutlinedVariants('neutral', 'neutral-700', 200, 200, 200, 50, 100)),
    outlined: cn(generateOutlinedVariants('neutral', 'neutral-700', 200, 200, 200, 50, 100))
  },
  link: {
    default: generateLinkVariants(color, `${color}-${shade}`, 600, 600, 700),
    outlined: generateLinkVariants(color, `${color}-${shade}`, 600, 600, 700)
  }
});

export const iconColorsTypes = (color = 'primary', style) => ({
  primary: style === 'default' ? 'white' : color,
  secondary: color ?? 'primary',
  tertiary: color ?? 'neutral',
  link: color ?? 'primary'
});
